/**
 * Context Bar - Premium page header with title and range selector
 * Replaces separate PageHeader + ReportingPeriodBar for unified hierarchy
 */
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext.jsx';
import ReportingPeriodBar from './ReportingPeriodBar.jsx';
import SelectionDebugChip from './SelectionDebugChip.jsx';

export default function ContextBar({ title, subtitle, children, titleInlineAction }) {
  const { theme } = useTheme();
  
  // Determine if we should render ReportingPeriodBar in the right column
  // If children is provided, use it; otherwise use ReportingPeriodBar
  // This allows pages to pass custom controls or ReportingPeriodBar explicitly
  const reportingControls = children || <ReportingPeriodBar />;

  return (
    <div className="owner-context-bar">
      <div className="owner-context-top">
        <div className="owner-context-left">
          <div className="owner-context-title-row">
            <h1 className="owner-context-title-h1">{title}</h1>
            <SelectionDebugChip />
            {titleInlineAction && (
              <div className="owner-context-title-action">
                {titleInlineAction}
              </div>
            )}
          </div>
          {subtitle && <p className="owner-context-subtitle">{subtitle}</p>}
        </div>
        <div className="owner-context-right">
          {reportingControls}
        </div>
      </div>
    </div>
  );
}

